import { render, staticRenderFns } from "./give-member.vue?vue&type=template&id=2abee0e1&"
import script from "./give-member.vue?vue&type=script&lang=js&"
export * from "./give-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports